import type { UpdateLeadSchema } from "../schema/lead-schema";

export const LEAD_FORM_DEFAULTS: UpdateLeadSchema = {
  name: "",
  phone: "",
  leadStat:"",
  marital:"",
  relationship:"",
  percentage:"",
  license:"",
  employmentStatus:"",
  earned:"",
  height:"",
  weight:"",
  unearned:"",
  worth:"",
  email:"",
  dob:"",
  gender:"",
  address:"",
  city:"",
  state:"",
  zipCode:"",
  notes:"",
  customFields: {},
};
